import React from "react";
import formatPrice from "./formatPrice";

const PACKETA_WIDGET_SCRIPT_URL = 'https://widget.packeta.com/v6/www/js/library.js';
const DELIVERY_METHOD_PICKUP = 'pickup';
const DELIVERY_METHOD_PACKETA = 'packeta';

let packetaWidgetScriptPromise = null;

function loadPacketaWidgetScript() {
    if (window.Packeta && window.Packeta.Widget) {
        return Promise.resolve();
    }
    if (!packetaWidgetScriptPromise) {
        packetaWidgetScriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = PACKETA_WIDGET_SCRIPT_URL;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Nepodařilo se načíst Packeta Widget.'));
            document.body.appendChild(script);
        });
    }
    return packetaWidgetScriptPromise;
}

const ReservationExternalStepDelivery = (props) => {
    const [method, setMethod] = React.useState(props.delivery?.method || null);
    const [point, setPoint] = React.useState(props.delivery?.point || null);
    const [widgetLoading, setWidgetLoading] = React.useState(false);
    const [validationError, setValidationError] = React.useState(null);

    const openPacketaWidget = () => {
        setValidationError(null);
        setWidgetLoading(true);
        loadPacketaWidgetScript().then(() => {
            setWidgetLoading(false);
            const options = {
                language: props.locale || 'cs',
                country: props.packetaCountry || 'cz',
                defaultPrice: props.packetaPrice || 0,
                defaultCurrency: 'CZK',
                // Restrict selection to Packeta's own pick-up points/boxes (excludes external
                // carriers' PUDOs) so the selected point's id always maps to a Packeta branch ID.
                vendors: [{country: props.packetaCountry || 'cz'}],
            };
            window.Packeta.Widget.pick(props.packetaWidgetApiKey, (selectedPoint) => {
                if (selectedPoint) {
                    setPoint(selectedPoint);
                }
            }, options);
        }).catch(() => {
            setWidgetLoading(false);
            setValidationError('Nepodařilo se načíst výběr výdejních míst. Zkuste to prosím znovu.');
        });
    };

    const handleNext = () => {
        if (!method) {
            setValidationError(window.translations.reservationExternal.delivery.noPickupPointSelected);
            return;
        }
        if (method === DELIVERY_METHOD_PACKETA && !point) {
            setValidationError(window.translations.reservationExternal.delivery.noPickupPointSelected);
            return;
        }
        setValidationError(null);
        props.onNext({method, point: method === DELIVERY_METHOD_PACKETA ? point : null});
    };

    return <>
        <h2 className={'h5 mt-3 text-uppercase'}>{window.translations.reservationExternal.delivery.heading}</h2>

        <div className={'bg-light p-3 mt-3'}>
            <div className="form-check">
                <input className="form-check-input" type="radio" name="deliveryMethod" id="deliveryMethodPickup"
                       checked={method === DELIVERY_METHOD_PICKUP}
                       onChange={() => setMethod(DELIVERY_METHOD_PICKUP)}/>
                <label className="form-check-label" htmlFor="deliveryMethodPickup">
                    <div className={'fw-bold'}>{window.translations.reservationExternal.delivery.personalPickup}</div>
                    <div className={'small text-muted'}>{window.translations.reservationExternal.delivery.personalPickupDescription}</div>
                </label>
            </div>
        </div>

        <div className={'bg-light p-3 mt-3'}>
            <div className="form-check">
                <input className="form-check-input" type="radio" name="deliveryMethod" id="deliveryMethodPacketa"
                       checked={method === DELIVERY_METHOD_PACKETA}
                       onChange={() => setMethod(DELIVERY_METHOD_PACKETA)}/>
                <label className="form-check-label" htmlFor="deliveryMethodPacketa">
                    <div className={'fw-bold'}>
                        {window.translations.reservationExternal.delivery.packeta}
                        {props.packetaPrice ? ` (${formatPrice(props.packetaPrice)})` : ''}
                    </div>
                    <div className={'small text-muted'}>{window.translations.reservationExternal.delivery.packetaDescription}</div>
                </label>
            </div>

            {method === DELIVERY_METHOD_PACKETA && (
                <div className={'mt-3'}>
                    {point ? (
                        <div className={'d-flex align-items-center justify-content-between'}>
                            <div>
                                <div className={'fw-bold small'}>{window.translations.reservationExternal.delivery.selectedPickupPoint}:</div>
                                <div>{point.name}</div>
                            </div>
                            <span className={'btn btn-secondary btn-sm'} onClick={openPacketaWidget}>
                                {window.translations.reservationExternal.delivery.changePickupPoint}
                            </span>
                        </div>
                    ) : (
                        <span className={'btn btn-primary btn-sm'} onClick={openPacketaWidget}>
                            {widgetLoading ? '...' : window.translations.reservationExternal.delivery.choosePickupPoint}
                        </span>
                    )}
                </div>
            )}
        </div>

        {validationError && <div className="alert alert-danger mt-3" role="alert">{validationError}</div>}

        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={props.onBack}><i
                className="fas fa-chevron-left me-3"></i> {window.translations.reservationExternal.back}</span>
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={handleNext}>{window.translations.reservationExternal.next} <i
                className="fas fa-chevron-right ms-3"></i></span>
        </div>
    </>;
};

export default ReservationExternalStepDelivery;
